<script setup>
import FeaturedCourseSingleComponent from './FeaturedCourseSingleComponent.vue';
import { useAuthStore } from '@stores/auth';
import {inject, markRaw} from 'vue';
import MainCourseEnrollComponent from '../../Client/Course/Enroll/MainCourseEnrollComponent.vue';

const authStore = useAuthStore();
const isAuthenticated = authStore.isAuthenticated;
const user = authStore.user;

const props = defineProps({
    courses: Array || null,
    route: String,
    routeEnroll: String,
    enrolledCourseIds: Object || null,
});

const modalEditState = inject('modalEditState');

const nonReactiveComponent = markRaw(MainCourseEnrollComponent);

const openEnrollModal = (data) => {
    modalEditState.open(
        nonReactiveComponent, {
            modalClass: 'xl:max-w-4xl',
            modalTitle: data.course.name,
            course: data.course,
            isAuthenticated: isAuthenticated,
            user: user,
            route: props.routeEnroll,
        },
        () => { modalEditState.close(); }
    )
};

</script>

<template>
    <!-- Featured Courses -->
    <div class="container py-6">
        <h2 class="header-2 text-primary-1 mb-6 lg:mb-8">Available Evidence Based Courses</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10">
            <featured-course-single-component
                v-for="course in courses"
                :key="course.id"
                :course="course"
                :route="route"
                :is-authenticated="isAuthenticated"
                :user="user"
                :enrolled-course-ids="enrolledCourseIds"
                @open-enroll-modal="openEnrollModal($event)"
            >
            </featured-course-single-component>
        </div>
    </div>
</template>

<style scoped>

</style>
